import React from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { X, CheckCircle } from "lucide-react";
import ModalOverlay from "../ModalOverlay/ModalOverlay.tsx";
import { closeWorkBagSuccessModal, openInviteToRegisterModal } from "../../../store/actions/profileActions";
import { openIdentityModal } from "../../../store/actions/registerActions";
import styles from "./WorkBagSuccessModal.module.scss";

const modalVariants = {
  hidden: { opacity: 0, scale: 1.1, y: 20 },
  visible: {
    opacity: 1,
    scale: 1.0,
    y: 0,
    transition: { delay: 0.1, duration: 0.3, ease: "easeOut" },
  },
};

interface WorkBagSuccessModalProps {
  workBagSuccessModal: false | { open: true; email: string };
  closeWorkBagSuccessModal: () => void;
  openIdentityModal: (value: boolean, email: string) => void;
  openInviteToRegisterModal: () => void;
}

const WorkBagSuccessModal: React.FC<WorkBagSuccessModalProps> = ({
  workBagSuccessModal,
  closeWorkBagSuccessModal,
  openIdentityModal,
  openInviteToRegisterModal,
}) => {
  const isOpen = Boolean(workBagSuccessModal && workBagSuccessModal.open);
  const email = workBagSuccessModal && workBagSuccessModal.open ? workBagSuccessModal.email : "";

  const handleValidateIdentity = () => {
    closeWorkBagSuccessModal();
    openIdentityModal(true, email);
  };

  const handleNoThanks = () => {
    closeWorkBagSuccessModal();
    openInviteToRegisterModal("after_work_bag_skip");
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={true} onClose={handleNoThanks}>
      <motion.div
        className={styles.modal}
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
      >
        <div className={styles.modalBody}>
          <button
            className={styles.closeButton}
            onClick={handleNoThanks}
            aria-label="Cerrar modal"
          >
            <X size={20} />
          </button>

          <div className={styles.content}>
            <div className={styles.iconContainer}>
              <CheckCircle size={48} className={styles.successIcon} />
            </div>

            <h3 className={styles.title}>¡Registro exitoso!</h3>

            <p className={styles.bodyText}>
              Tus datos se cargaron correctamente en la bolsa de trabajo. Te
              notificaremos por email cuando haya ofertas que coincidan con tu
              perfil.
            </p>

            <div className={styles.whyBlock}>
              <p className={styles.whyTitle}>¿Por qué validar tu identidad?</p>
              <ul className={styles.whyList}>
                <li className={styles.whyItem}>
                  Las empresas priorizan perfiles verificados para contactar
                  candidatos.
                </li>
                <li className={styles.whyItem}>
                  Es un requisito para postularte a las ofertas publicadas en la
                  bolsa.
                </li>
                <li className={styles.whyItem}>
                  Solo tenés que subir fotos de tu DNI y una selfie; el proceso
                  es rápido y seguro.
                </li>
              </ul>
            </div>
          </div>

          <div className={styles.options}>
            <button
              className={styles.primaryButton}
              onClick={handleValidateIdentity}
              type="button"
            >
              Validar mi identidad
            </button>
            <button
              className={styles.secondaryButton}
              onClick={handleNoThanks}
              type="button"
            >
              No, gracias lo haré después
            </button>
          </div>
        </div>
      </motion.div>
    </ModalOverlay>
  );
};

const mapStateToProps = (state: {
  general: { workBagSuccessModal: false | { open: true; email: string } };
}) => ({
  workBagSuccessModal: state.general.workBagSuccessModal,
});

export default connect(mapStateToProps, {
  closeWorkBagSuccessModal,
  openIdentityModal,
  openInviteToRegisterModal,
})(WorkBagSuccessModal);
